import { Check } from "lucide-react";
import { Reveal, MaskedHeading, ParallaxImage } from "../Reveal";
import { REASSURANCE, IMAGES } from "../../data/content";

export default function Reassurance() {
  return (
    <section className="section bg-abyss py-24 md:py-36" data-testid="reassurance-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num">CHAPITRE 09 — CONCRÈTEMENT</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.1rem,4.6vw,3.8rem)] leading-tight tracking-tight text-pearl mt-8 max-w-4xl"
          lines={["Concrètement,", "en t'inscrivant, tu recevras…"]}
        />

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mt-12 items-start">
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-5">
              {REASSURANCE.map((r, i) => (
                <Reveal key={i} delay={(i % 2) * 0.08} className="flex gap-4 items-start py-4 border-b border-pearl/12">
                  <span className="mt-1 text-aqua shrink-0">
                    <Check size={18} strokeWidth={1.8} />
                  </span>
                  <span className="text-pearl/85 text-lg leading-snug">{r}</span>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1} className="mt-12 space-y-5">
              <p className="text-pearl/75 text-lg leading-relaxed">
                Aucune expérience préalable n'est nécessaire. Tu n'as pas besoin de connaître
                les dauphins, de méditer depuis vingt ans ou d'avoir déjà compris ce que
                l'univers essaie de te dire.
              </p>
              <p className="font-display italic text-2xl md:text-3xl leading-snug text-aqua">
                Tu as seulement besoin d'une connexion internet, de quelques espaces de
                disponibilité et de l'envie d'entrer sincèrement dans l'expérience.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <ParallaxImage
              src={IMAGES.faceStill}
              alt="Adulte contemplant l'horizon marin à l'aube"
              className="aspect-[4/5] rounded-sm"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
